require('normalize.css/normalize.css')
// Load Typefaces
require('typeface-montserrat/index.css')
require('typeface-roboto/index.css')
require('typeface-lato/index.css')
// Load Icons
require('@fortawesome/fontawesome-free/css/all.css')
require('material-icons/iconfont/material-icons.css')
require('./designsystem/css/designsystem.css')
